import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function favouriteReducer(state = initialState.favourited, action) {
  switch (action.type) {
    case types.LOAD_FAVOURITE_SUCCESS:
      return action.favourited;

    case types.ADD_FAVOURITE_SUCCESS:
      return true;

    case types.REMOVE_FAVOURITE_SUCCESS:
      return false;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/favouriteReducer.js